import React from 'react';

const Loading = () => {
  return (
    <div className="">
        <p className="text-center font-medium mb-40 mt-20 py-20">Hleður gögn...</p>
    </div>
    
  );
};

export default Loading;